"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterMembersByFieldFilter = void 0;
const isEmpty_1 = __importDefault(require("lodash-es/isEmpty"));
const react_fast_compare_1 = __importDefault(require("react-fast-compare"));
const types_1 = require("@smartsuite/types");
const filter_1 = require("./filter");
function filterMembersByFieldFilter(field, structure, members) {
    var _a;
    const fieldFilter = (_a = field.params.field_filter) !== null && _a !== void 0 ? _a : types_1.emptyFilterData;
    const includeFilter = field.params.include_filter;
    if (!includeFilter || isFieldFilterEmpty(fieldFilter)) {
        return members;
    }
    return (0, filter_1.filterRecords)(members, structure, fieldFilter.operator, fieldFilter.fields);
}
exports.filterMembersByFieldFilter = filterMembersByFieldFilter;
function isFieldFilterEmpty(fieldFilter) {
    return (!fieldFilter ||
        (0, isEmpty_1.default)(fieldFilter) ||
        (0, react_fast_compare_1.default)(fieldFilter, types_1.emptyFilterData));
}
